import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__ from "@radix-ui/react-icons";
import * as __WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__ from "react-day-picker";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const removeTwPrefixes = (obj)=>Object.fromEntries(Object.entries(obj).map(([key, value])=>[
            key,
            value.replace(/\btw-/g, "")
        ]));
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    const baseClassNames = {
        root: "tw-relative tw-box-border",
        day: "tw-w-[2.25rem] tw-h-[2.25rem] tw-text-center",
        day_button: "tw-relative tw-p-0 tw-m-0 tw-cursor-pointer tw-font-inherit tw-text-inherit tw-flex tw-justify-center tw-items-center tw-w-[2.25rem] tw-h-[2.25rem] tw-border-2 tw-border-transparent tw-rounded-full tw-text-sm",
        day_button_disabled: "tw-cursor-auto",
        caption_label: "tw-z-10 tw-relative tw-inline-flex tw-items-center tw-whitespace-nowrap tw-border-none",
        button_next: "tw-rounded-sm tw-border tw-border-slate-300 tw-bg-none tw-p-0 tw-m-0 tw-cursor-pointer tw-font-inherit tw-text-inherit tw-inline-flex tw-items-center tw-justify-center tw-w-[1.75rem] tw-h-[1.75rem] hover:tw-bg-slate-100",
        button_previous: "tw-rounded-sm tw-border tw-border-slate-300 tw-bg-none tw-p-0 tw-m-0 tw-cursor-pointer tw-font-inherit tw-text-inherit tw-inline-flex tw-items-center tw-justify-center tw-w-[1.75rem] tw-h-[1.75rem] hover:tw-bg-slate-100",
        button_disabled: "tw-opacity-50 tw-cursor-auto",
        chevron: "tw-inline-block tw-fill-current",
        dropdowns: "tw-relative tw-inline-flex tw-items-center tw-gap-2",
        dropdown: "tw-opacity-0 tw-appearance-none tw-absolute tw-inset-0 tw-w-full tw-m-0 tw-p-0 tw-cursor-auto tw-border-none tw-line-height-inherit",
        dropdown_root: "tw-relative tw-inline-flex tw-items-center",
        month_caption: "tw-flex tw-items-center tw-h-[2.75rem] tw-text-md tw-px-3",
        months: "tw-relative tw-flex tw-flex-wrap tw-gap-8 tw-max-w-fit",
        month_grid: "tw-border-collapse",
        nav: "tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-gap-2 tw-h-[2.75rem]",
        weekday: "tw-opacity-50 tw-py-2 tw-font-medium tw-text-sm tw-text-center !tw-bg-transparent",
        week_number: "tw-opacity-75 tw-font-normal tw-text-sm tw-h-[2.75rem] tw-w-[2.75rem] tw-border-2 tw-border-transparent tw-rounded-full tw-text-center",
        today: "tw-text-blue-500",
        selected: "tw-text-md tw-text-white tw-rounded-full [&>*]:tw-bg-slate-800",
        selected_day_button: "tw-border-2 tw-border-blue-500",
        outside: "tw-opacity-75",
        disabled: "tw-opacity-50",
        hidden: "tw-invisible",
        range_start: "tw-relative before:tw-content-[''] before:tw-absolute before:tw-top-0 before:tw-right-0 before:tw-bottom-0 before:tw-left-[50%] before:tw-bg-slate-100",
        range_start_day_button: "tw-bg-blue-500 tw-text-white",
        range_middle: "tw-bg-slate-100 tw-text-slate-800 tw-rounded-none [&>*]:tw-bg-transparent [&>*]:tw-text-slate-800",
        range_middle_day_button: "tw-border-none tw-rounded-none tw-text-inherit",
        range_end: "tw-relative before:tw-content-[''] before:tw-absolute before:tw-top-0 before:tw-left-0 before:tw-bottom-0 before:tw-right-[50%] before:tw-bg-slate-100",
        range_end_day_button: "tw-bg-blue-500 tw-text-white",
        focusable: "tw-cursor-pointer"
    };
    const mergedClassNames = {
        ...baseClassNames,
        ...removeTwPrefixes(classNames || {})
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__.DayPicker, {
        showOutsideDays: showOutsideDays,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-p-3", className),
        classNames: mergedClassNames,
        components: {
            Chevron: (props)=>{
                if ("left" === props.orientation) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronLeftIcon, {
                    className: "tw-h-4 tw-w-4",
                    ...props
                });
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronRightIcon, {
                    className: "tw-h-4 tw-w-4",
                    ...props
                });
            }
        },
        ...props
    });
}
Calendar.displayName = "Calendar";
export { Calendar };

//# sourceMappingURL=calendar.mjs.map